'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _makeSymbol;

var _uniqueId = require('../uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _makeSymbol(name) {
  return typeof Symbol === 'function' ? Symbol(name) : (0, _uniqueId2.default)(name);
}
module.exports = exports['default'];